import React from 'react';
import Icon from '../AppIcon';

const QuickActionPanel = ({ 
  userRole = 'admin',
  onCreateWorkOrder,
  onUpdateStatus,
  onViewPending,
  onGenerateQuote,
  onViewReports,
  onScheduleService,
  onViewSolicitudes,
  solicitudesCount = 0,
  solicitudesUrgent = false,
  compact = false
}) => {
  const solicitudesAction = {
    id: 'view-solicitudes',
    label: 'Solicitudes',
    description: 'Solicitudes del portal cliente',
    icon: 'MessageSquare',
    color: 'solicitudes',
    onClick: onViewSolicitudes,
    shortcut: 'Ctrl+S',
    badge: solicitudesCount > 0 ? solicitudesCount : null,
    urgent: solicitudesUrgent,
    hasAlert: solicitudesCount > 0
  };

  const actionsByRole = {
    recepcion: [
      solicitudesAction,
      {
        id: 'create-work-order',
        label: 'Recepción de Unidad',
        description: 'Registrar recepción del vehículo',
        icon: 'ClipboardList',
        color: 'primary',
        onClick: onCreateWorkOrder,
        shortcut: 'Ctrl+R'
      },
      {
        id: 'view-pending',
        label: 'Pendientes',
        description: 'Ver órdenes pendientes',
        icon: 'Clock',
        color: 'warning',
        onClick: onViewPending,
        shortcut: 'Ctrl+P'
      },
    ],
    taller: [
      {
        id: 'create-work-order',
        label: 'Recepción de Unidad',
        description: 'Registrar recepción del vehículo',
        icon: 'ClipboardList',
        color: 'primary',
        onClick: onCreateWorkOrder,
        shortcut: 'Ctrl+R'
      },
      {
        id: 'update-status',
        label: 'Actualizar Estado',
        description: 'Cambiar estado de orden',
        icon: 'RefreshCw',
        color: 'accent',
        onClick: onUpdateStatus,
        shortcut: 'Ctrl+U'
      },
      {
        id: 'schedule-service',
        label: 'Agendar Servicio',
        description: 'Crear cita en calendario',
        icon: 'Calendar',
        color: 'secondary',
        onClick: onScheduleService,
        shortcut: 'Ctrl+A'
      },
      {
        id: 'view-reports',
        label: 'Reportes',
        description: 'Ver métricas',
        icon: 'BarChart3',
        color: 'warning',
        onClick: onViewReports,
        shortcut: 'Ctrl+I'
      },
      {
        id: 'view-pending',
        label: 'Mis Órdenes',
        description: 'Ver órdenes asignadas',
        icon: 'Wrench',
        color: 'warning',
        onClick: onViewPending,
        shortcut: 'Ctrl+M'
      },
    ],
    ventas: [
      {
        id: 'generate-quote',
        label: 'Nueva Cotización',
        description: 'Crear presupuesto',
        icon: 'FileText',
        color: 'primary',
        onClick: onGenerateQuote,
        shortcut: 'Ctrl+Q'
      },
      {
        id: 'view-pending',
        label: 'Seguimiento',
        description: 'Clientes pendientes',
        icon: 'Users',
        color: 'secondary',
        onClick: onViewPending,
        shortcut: 'Ctrl+S'
      }
    ],
    direccion: [
      solicitudesAction,
      {
        id: 'view-reports',
        label: 'Reportes',
        description: 'Ver métricas',
        icon: 'BarChart3',
        color: 'primary',
        onClick: onViewReports,
        shortcut: 'Ctrl+R'
      },
      {
        id: 'view-pending',
        label: 'Supervisión',
        description: 'Estado general',
        icon: 'Eye',
        color: 'accent',
        onClick: onViewPending,
        shortcut: 'Ctrl+O'
      },
    ],
    admin: [
      solicitudesAction,
      {
        id: 'create-work-order',
        label: 'Recepción de Unidad',
        description: 'Registrar recepción del vehículo',
        icon: 'ClipboardList',
        color: 'primary',
        onClick: onCreateWorkOrder,
        shortcut: 'Ctrl+R'
      },
      {
        id: 'generate-quote',
        label: 'Cotización',
        description: 'Crear presupuesto',
        icon: 'FileText',
        color: 'secondary',
        onClick: onGenerateQuote,
        shortcut: 'Ctrl+Q'
      },
      {
        id: 'schedule-service',
        label: 'Agendar Servicio',
        description: 'Crear cita en calendario',
        icon: 'Calendar',
        color: 'accent',
        onClick: onScheduleService,
        shortcut: 'Ctrl+A'
      },
      {
        id: 'view-reports',
        label: 'Reportes',
        description: 'Ver métricas',
        icon: 'BarChart3',
        color: 'warning',
        onClick: onViewReports,
        shortcut: 'Ctrl+I'
      },
      {
        id: 'view-pending',
        label: 'Pendientes',
        description: 'Todas las órdenes',
        icon: 'Clock',
        color: 'warning',
        onClick: onViewPending,
        shortcut: 'Ctrl+P'
      },
    ]
  };

  const actions = actionsByRole?.[userRole] || actionsByRole?.admin;

  const colorClasses = {
    primary: {
      bg: 'bg-primary',
      text: 'text-primary-foreground',
      hover: 'hover:bg-primary/90',
      icon: 'text-primary',
      iconBg: 'bg-primary/10'
    },
    secondary: {
      bg: 'bg-secondary',
      text: 'text-secondary-foreground',
      hover: 'hover:bg-secondary/90',
      icon: 'text-secondary',
      iconBg: 'bg-secondary/10'
    },
    accent: {
      bg: 'bg-accent',
      text: 'text-accent-foreground',
      hover: 'hover:bg-accent/90',
      icon: 'text-accent',
      iconBg: 'bg-accent/10'
    },
    warning: {
      bg: 'bg-warning',
      text: 'text-warning-foreground',
      hover: 'hover:bg-warning/90',
      icon: 'text-warning',
      iconBg: 'bg-warning/10'
    },
    success: {
      bg: 'bg-success',
      text: 'text-success-foreground',
      hover: 'hover:bg-success/90',
      icon: 'text-success',
      iconBg: 'bg-success/10'
    },
    solicitudes: {
      bg: 'bg-red-600',
      text: 'text-white',
      hover: 'hover:bg-red-700',
      icon: 'text-red-600',
      iconBg: 'bg-red-100'
    }
  };

  if (compact) {
    return (
      <div className="flex flex-wrap gap-2">
        {actions?.map((action) => {
          const isSolicitudes = action?.id === 'view-solicitudes';
          const hasAlert = isSolicitudes && action?.hasAlert;
          const isUrgent = isSolicitudes && action?.urgent;
          const colors = colorClasses?.[action?.color] || colorClasses?.primary;
          return (
            <button
              key={action?.id}
              onClick={action?.onClick}
              className={`
                relative flex items-center gap-2 px-4 py-2 rounded-lg
                ${hasAlert && isUrgent
                  ? 'bg-red-600 text-white hover:bg-red-700'
                  : hasAlert
                  ? 'bg-orange-500 text-white hover:bg-orange-600'
                  : `${colors?.bg} ${colors?.text} ${colors?.hover}`}
                font-body font-medium text-sm
                transition-smooth press-effect focus-ring
                shadow-elevation-1 hover:shadow-elevation-2
              `}
              style={hasAlert ? { animation: 'solicitudesPulse 2.5s ease-in-out infinite' } : undefined}
              title={`${action?.description} (${action?.shortcut})`}
            >
              <Icon name={action?.icon} size={16} />
              <span>{action?.label}</span>
              {action?.badge != null && (
                <span className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] flex items-center justify-center rounded-full bg-white text-red-600 text-xs font-bold px-1 shadow">
                  {action?.badge > 99 ? '99+' : action?.badge}
                </span>
              )}
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border shadow-elevation-2 p-6">
      <div className="flex items-center gap-2 mb-6">
        <Icon name="Zap" size={24} className="text-accent" />
        <h2 className="text-xl font-heading font-semibold text-foreground">
          Acciones Rápidas
        </h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {actions?.map((action) => {
          const isSolicitudes = action?.id === 'view-solicitudes';
          const hasAlert = isSolicitudes && action?.hasAlert;
          const isUrgent = isSolicitudes && action?.urgent;
          const colors = colorClasses?.[action?.color] || colorClasses?.primary;
          return (
            <button
              key={action?.id}
              onClick={action?.onClick}
              className={`
                relative flex flex-col items-start gap-3 p-4 rounded-lg
                ${hasAlert && isUrgent
                  ? 'bg-red-50 border-2 border-red-500 hover:bg-red-100'
                  : hasAlert
                  ? 'bg-orange-50 border-2 border-orange-400 hover:bg-orange-100' :'bg-muted/50 border border-border hover:bg-muted hover:shadow-elevation-1'
                }
                transition-smooth hover-lift press-effect focus-ring
                text-left
              `}
              style={hasAlert ? { animation: 'solicitudesPulse 2.5s ease-in-out infinite' } : undefined}
              title={action?.shortcut}
            >
              {/* Badge */}
              {action?.badge != null && (
                <span className="absolute top-2 right-2 min-w-[22px] h-[22px] flex items-center justify-center rounded-full bg-red-600 text-white text-xs font-bold px-1.5 shadow-md">
                  {action?.badge > 99 ? '99+' : action?.badge}
                </span>
              )}
              <div className={`p-2 rounded-lg ${hasAlert && isUrgent ? 'bg-red-100' : hasAlert ? 'bg-orange-100' : colors?.iconBg || 'bg-primary/10'}`}>
                <Icon
                  name={action?.icon}
                  size={24}
                  className={hasAlert && isUrgent ? 'text-red-600' : hasAlert ? 'text-orange-500' : colors?.icon}
                />
              </div>
              <div className="flex-1">
                <h3 className={`text-base font-heading font-semibold mb-1 ${hasAlert && isUrgent ? 'text-red-700' : hasAlert ? 'text-orange-600' : 'text-foreground'}`}>
                  {action?.label}
                </h3>
                <p className="text-sm caption text-muted-foreground">
                  {action?.description}
                </p>
              </div>
              <div className="flex items-center justify-between w-full">
                <span className="text-xs caption text-muted-foreground font-mono">
                  {action?.shortcut}
                </span>
                <Icon name="ArrowRight" size={16} className={hasAlert && isUrgent ? 'text-red-500' : hasAlert ? 'text-orange-400' : 'text-muted-foreground'} />
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default QuickActionPanel;